import Vue from 'vue';
import { API_BASE_URL } from '@/config';
export default {
  send_message (data) {
    return Vue.http.post(API_BASE_URL + 'v1/message/send', data);
  }
};

